import { render, staticRenderFns } from "./WaitingOrder.vue?vue&type=template&id=23c3538a&lang=pug&"
import script from "./WaitingOrder.vue?vue&type=script&lang=ts&"
export * from "./WaitingOrder.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingOrder.vue?vue&type=style&index=0&id=23c3538a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports